<template>
  <div>
    <section class="page-content">
      <div class="row">
        <div class="col-md-12">
          <form action @submit.prevent="next">
            <article class="input-section form-section">
              <label>
                <strong>
                  <span class="mr-1">IMPORTANT NOTE:</span>
                  The applicant’s disclosure of claim information does not indicate nor imply, in any way, that any act
                  or omission is covered by this policy. In addition, circumstances or incidents that might reasonably be expected to be the
                  basis of a claim MUST be reported to the applicant’s current insurer before the claim reporting period expires.
                </strong>
              </label>
            </article>
            <article class="input-section form-section">
              <div class="row">
                <div class="col-md-9 col-sm-12">
                  <label for class="orep-label">
                    <span class="mr-1">26.</span>
                    During the past 5 years has any
                    insurance carrier declined, canceled or refused renewal of similar insurance on behalf of this applicant or
                    anyone to whom this insurance will apply (Other than due to loss of market)?
                    <br />
                    (This question does not apply to Missouri Applicants)
                  </label>
                </div>
                <div class="col-md-3 d-flex flex-column">
                  <div class="d-flex flex-row">
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                          type="radio"
                          name="doesApplicantInsuranceDeclined"
                          value="true"
                          class="orep-radio"
                          @change="validateBeforeSubmit()"
                          v-model="standardApplication.doesApplicantInsuranceDeclined"
                        >
                        <span class="radio-span">Yes</span>
                      </label>
                    </div>
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                          type="radio"
                          name="doesApplicantInsuranceDeclined"
                          value="false"
                          class="orep-radio"
                          @change="validateBeforeSubmit()"
                          v-model="standardApplication.doesApplicantInsuranceDeclined"
                        >
                        <span class="radio-span">No</span>
                      </label>
                    </div>
                  </div>
                  <span
                    v-show="errors.has('doesApplicantInsuranceDeclined')"
                    class="help is-danger form-errors text-danger"
                  >{{ errors.first('doesApplicantInsuranceDeclined') | filterText }}</span>
                </div>
              </div>
              <div class="col-md-auto d-flex flex-column">
                <p v-show="standardApplication.doesApplicantInsuranceDeclined === 'true' || standardApplication.doesApplicantInsuranceDeclined == 'true'" class="text-danger">
                  If Yes, provide details on a separate sheet and include the date, carrier and reason. (Email: <a href="mailto:info@orep.org" target="_top">info@orep.org</a>)
                </p>
              </div>
            </article>
            <article class="input-section form-section d-flex flex-column">
              <div class="row">
                <div class="col-md-9 col-sm-12">
                  <label for class="orep-label">
                    <span class="mr-1">28.</span>
                    Has the applicant ever purchased an extended reporting period endorsement?
                  </label>
                </div>
                <div class="col-md-3 d-flex flex-column">
                  <div class="d-flex flex-row">
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                          type="radio"
                          name="hasApplicantEverPurchasedReporting"
                          value="true"
                          class="orep-radio"
                          v-validate="'required'"
                          @change="validateBeforeSubmit()"
                          v-model="standardApplication.hasApplicantEverPurchasedReporting"
                        >
                        <span class="radio-span">Yes</span>
                      </label>
                    </div>
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                          type="radio"
                          name="hasApplicantEverPurchasedReporting"
                          value="false"
                          class="orep-radio"
                          @change="validateBeforeSubmit()"
                          v-model="standardApplication.hasApplicantEverPurchasedReporting"
                        >
                        <span class="radio-span">No</span>
                      </label>
                    </div>
                  </div>
                  <span
                    v-show="errors.has('hasApplicantEverPurchasedReporting')"
                    class="help is-danger form-errors text-danger"
                  >{{ errors.first('hasApplicantEverPurchasedReporting') | filterText }}</span>
                </div>
              </div>
              <div class="col-md-auto d-flex flex-column" v-if="standardApplication.hasApplicantEverPurchasedReporting == true || standardApplication.hasApplicantEverPurchasedReporting === 'true'">
              <label class="orep-label text-danger">If Yes, provide details to include the date, carrier and reason.
              </label>

              <input
                type="text"
                placeholder="Please explain:"
                class="orep-text-input js-orep-input"
                v-if="standardApplication.hasApplicantEverPurchasedReporting == true || standardApplication.hasApplicantEverPurchasedReporting === 'true'"
                name="hasApplicantEverPurchasedReportingDetails"
                v-model="standardApplication.hasApplicantEverPurchasedReportingDetails"
              >
              </div>
            </article>
            <article class="input-section form-section">
              <label class="orep-label">
                <span class="mr-1">29.</span>Coverage Section:
              </label>

                <div class="row align-items-center">
                  <label class="orep-label mb-0 col-md-6">
                    a. Limits of Liability (Per Claim / Aggregate):
                  </label>
                  <select
                    class="orep-select col-md-3"                    
                    name="limitOfCoverage"
                    v-model="standardApplication.limitOfCoverage"
                    v-validate="'required'"
                    @change="validateBeforeSubmit()"
                  >
                    <option value="0.25M/0.25M">$250,000 / $250,000</option>
                    <option value="0.5M/0.5M">$500,000 / $500,000</option>
                    <option value="0.5M/1M">$500,000 / $1,000,000</option>
                    <option value="1M/1M">$1,000,000 / $1,000,000</option>
                    <option value="1M/2M">$1,000,000 / $2,000,000</option>
                  </select>
                </div>
                <span
                  v-show="errors.has('limitOfCoverage')"
                  class="help is-danger form-errors text-danger"
                >{{ errors.first('limitOfCoverage') | filterText }}</span>

              <div class="row align-items-center" style="margin-top: 25px;margin-bottom: 25px;">
                <label class="orep-label mb-0 col-md-6">
                  <span class="mr-2"></span>
                  b. Deductible:
                </label>
                <select
                  class="orep-select col-md-3"                  
                  name="deductible"
                  v-model="standardApplication.deductible"
                  v-validate="'required'"
                >
                  <option value="1000">$1,000</option>
                  <option value="1000">$1,500</option>
                  <option value="2500">$2,500</option>
                  <option value="5000">$5,000</option>
                </select>
              </div>
              <span
                v-show="errors.has('deductible')"
                class="help is-danger form-errors text-danger"
              >{{ errors.first('deductible') | filterText }}</span>



              <div class="row align-items-center py-2">
                <label class="mb-0 col-md-4">c. Desired Effective Date:</label>
                <datepicker
                  name="effectiveDate"
                  v-model="standardApplication.effectiveDate"
                  v-validate="'required'"
                  format="MM/dd/yyyy"
                  input-class="orep-text-input w-75"
                  @input="validateBeforeSubmit()"
                  :disabled="state.effectiveDateValid"
                  :clearButton="false"
                  :value="computedDates"
                  class="col-md-4"
                ></datepicker>
                <span
                  v-show="errors.has('effectiveDate')"
                  class="help is-danger form-errors text-danger"
                >{{ errors.first('effectiveDate') | filterText }}</span>
              </div>
              <div class="row align-items-center py-2">
                <label class="mb-0 col-md-4">d. Current Policy Retroactive Date:</label>
                <datepicker
                  name="retroactiveDate"
                  class="col-md-4"
                  v-model="standardApplication.retroactiveDate"
                  format="MM/dd/yyyy"
                  input-class="orep-text-input w-75"
                  @input="validateBeforeSubmit()"
                  :disabled="state.retroactiveDateValid"
                  :clearButton="false"
                  :value="computedDates"
                ></datepicker>
              </div>
            </article>
          </form>
        </div>
      </div>
    </section>
    <div class="row">
      <div class="col-md-12">
        <section class="flex wrap bottom-section">
          <router-link :to="{name:'standard-application-3'}" class="next-btn back-btn flex mont spaced">
            <i class="fas fa-arrow-left"></i>
            Back
          </router-link>
          <article class="orep-pagination">
            <button class="pagination-dots" @click="navigateToOne()"></button>
            <button class="pagination-dots" @click="navigateToPrev('standard-application-2')"></button>
            <button class="pagination-dots" @click="navigateToPrev('standard-application-3')" :disabled="!state.pageThreeIsValid"></button>
            <span class="pagination-dots pagination-current"></span>
            <button
              class="pagination-dots"
              @click="navigateToNext('standard-application-5')"
              :disabled="!state.pageThreeIsValid || !state.pageFourIsValid">
            </button>
            <button
                class="pagination-dots"
                @click="navigateToNext('standard-application-6')"
                :disabled="!state.pageThreeIsValid || !state.pageFourIsValid || !state.pageFiveIsValid">
            </button>
            <button
                class="pagination-dots"
                @click="navigateToNext('standard-application-7')"
                :disabled="!state.pageSixIsValid">
            </button>
            <button
                class="pagination-dots"
                @click="navigateToNext('standard-application-8')"
                :disabled="!state.pageOneIsValid || !state.pageTwoIsValid || !state.pageThreeIsValid || !state.pageFourIsValid || !state.pageFiveIsValid || !state.pageSixIsValid || !state.pageSevenIsValid">
            </button>
          </article>
          <button type="submit" :disabled="!state.pageFourIsValid"
            :class="{submitDisabled: !state.pageFourIsValid}" class="next-btn mont spaced pull-right" @click="navigateToNext('standard-application-5')">Next</button>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import Datepicker from 'vuejs-datepicker';
import {APP_STATUS, STATES, STATUS} from "../../utils/constants";

var moment = require('moment')
export default {
  name: "standard-application-4",
  computedDates () {
    return moment(this.value).format('YYYY-MM-D')
  },
  computed: {
    standardApplication() {
      return this.$store.state.standardApplication.standardApplication;
    },
    state() {
      return this.$store.state.standardApplication;
    },
    errorMsg() {
      return this.$store.state.standardApplication.errorMsg;
    },
  },
  watch: {
    errorMsg: {
      handler() {
        if (this.errorMsg) {
          this.$notify({
            group: 'error',
            type: 'error',
            text: this.errorMsg,
            duration: 15000
          });
        }
      }
    }
  },
  methods: {
    navigateToOne() {
      this.$router.push({
        name: "standard-application-1"
      });
    },

    navigateToPrev(routeName) {
      this.$router.push({
        name: routeName
      });
    },
    navigateToNext(routeName) {
      this.$router.push({
        name: routeName
      });
    },

    validateBeforeSubmit() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.state.pageFourIsValid = true;
          return;
        }
        this.state.pageFourIsValid = false;
      });
    }
  },

  mounted() {
    $("html, body").animate(
      {
        scrollTop: $(".page-content").offset().top
      },
      500
    );
  },

  filters: {
    filterText(x) {
      if (x !== undefined) {
        if (x.indexOf("req") !== -1) {
          return "This field is required";
        } else {
          return x.replace("_", " ");
        }
      }
    }
  },
  components: {
    Datepicker
  }
};
</script>

<style scoped>
  table td, table th {
    border: 1px solid black;
  }
  table th {
    height: 35px;
  }
  table td, table th {
    text-align: center;
    max-width: 140px;
  }
  table input {
    width: 100%;
    text-align: center;
  }
</style>
